import { useState, useEffect } from 'react';

const usePlotlyAnnotations = ({
  onDateSelected,
  onDateRemoved,
  initialVerticalLines = [],  // New prop to pass initial vertical lines
  shadedRegion = null  // New prop to pass a shaded region
}) => {
  const [annotations, setAnnotations] = useState([]);
  const [shapes, setShapes] = useState([]);

  // Initialize vertical lines and shaded region when the hook is first called
  useEffect(() => {
    let initialShapes = [];

    // Add initial vertical lines as shapes
    [...initialVerticalLines].forEach(date => {
      const newLine = {
        type: 'line',
        x0: date,
        x1: date,
        y0: 0,
        y1: 1,
        xref: 'x',
        yref: 'paper',
        line: {
          color: 'blue',
          width: 2,
          dash: 'dot',
        },
      };
      initialShapes.push(newLine);
    });

    // Add shaded region if provided
    if (shadedRegion) {
      const shadedShape = {
        type: 'rect',
        x0: shadedRegion.start,
        x1: shadedRegion.end,
        y0: 0,
        y1: 1,
        xref: 'x',
        yref: 'paper',
        fillcolor: 'rgba(50, 171, 96, 0.3)',  // Color for the shaded region
        opacity: 0.3,
        line: { width: 0 },
      };
      initialShapes.push(shadedShape);
    }

    // Set the initial shapes
    setShapes(initialShapes);
  }, [JSON.stringify(initialVerticalLines), JSON.stringify(shadedRegion)]);

  const handleAnnotationClick = (xValue) => {
    const existingIndex = annotations.findIndex(annotation => annotation.x === xValue);

    if (existingIndex !== -1) {
      // Remove annotation and shape
      const newAnnotations = annotations.filter((_, index) => index !== existingIndex);
      const newShapes = shapes.filter((_, index) => index !== existingIndex);

      // Trigger the onDateRemoved callback
      onDateRemoved(xValue);

      // Update the state
      setAnnotations(newAnnotations);
      setShapes(newShapes);
    } else {
      // Add a new vertical line as a shape
      const newLine = {
        type: 'line',
        x0: xValue,
        x1: xValue,
        y0: 0,
        y1: 1,
        xref: 'x',
        yref: 'paper',
        line: {
          color: 'red',
          width: 2,
          dash: 'dashdot',
        },
      };

      // Add text annotation with arrow
      const newAnnotation = {
        x: xValue,
        xref: "x",
        yref: "paper",
        y: 1,
        text: `${xValue}`,
        showarrow: false,
        arrowhead: 0,
        ax: 0,
        ay: -20,
      };

      // Trigger the onDateSelected callback
      onDateSelected(xValue);

      // Update the state with the new annotation and shape
      setAnnotations([...annotations, newAnnotation]);
      setShapes([...shapes, newLine]);
    }


  };


  const removeAllAnnotations = () => {
      setAnnotations([]);
      setShapes([]);
  };

  return {
    annotations,
    shapes,
    handleAnnotationClick,
    removeAllAnnotations
  };
};

export default usePlotlyAnnotations;
